import React from "react";
import "./faqs.css";
import QuestionsTab from "./QuestionsTab";

function tamperProofFAQs() {
  return (
    <div className="faq-wrapper">
      <div className="faq-heading">
        Answers Transparent, Like Our {" "}
        <span style={{ color: "#6D2FEC" }}>
          Tamper 
          <br />
          Reports
        </span>
      </div>
      <div className="faq-questions-tab">
        <QuestionsTab
          ques={"How does TamperProof detect forgery so accurately?"}
          ans={
            "TamperProof uses advanced PDF tampering detection to inspect every layer of a file from metadata to text, signatures, and embedded files; catching even the slightest tampering attempt."
          }
        />
        <QuestionsTab
          ques={"What kind of documents can I check with TamperProof?"}
          ans={
            "From bank statements and payslips to offer letters and academic PDFs, TamperProof acts as a document verification software that validates integrity across a wide range of critical documents."
          }
        />
        <QuestionsTab
          ques={"How does TamperProof validate digital signatures?"}
          ans={
            "By verifying authenticity with cryptographic checks and private-public key hash matching, ensuring your documents can’t be forged."
          }
        />
        <QuestionsTab
          ques={"Can TamperProof handle bulk checks for enterprises?"}
          ans={
            "Yes. You can upload and analyze hundreds of documents in one go, with analytics and dashboards built for high-volume lenders, BFSI, and HR-Tech teams."
          }
        />
        <QuestionsTab
          ques={
            "How does TamperProof generate reports for bulk uploads and track history?"
          }
          ans={
            "TamperProof generates detailed reports with verdicts, timestamps, and edit maps for each document. Enterprises can access audit logs, track verification history, and export analytics to streamline compliance and decision-making."
          }
        />
        <QuestionsTab
          ques={"Can I get customized features for TamperProof?"}
          ans={
            "Yes. Basic offers metadata tampering detection; Advanced includes pixel-level edit tracking; Supreme adds AI-driven pattern recognition and structural analysis. Custom options are also available for specific needs."
          }
        />
      </div>
    </div>
  );
}

export default React.memo(tamperProofFAQs);
